import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Card,
    CardMedia,
    CardContent,
    Container,
    Grid,
} from "@mui/material";
import figLogo from "../../assets/SWAN-Ai-Lab_.png";

const Dashboard = () => {
    const [pages, setPages] = useState([]);

    useEffect(() => {
        const fetchPages = async () => {
            try {
                const response = await fetch("https://api.swancreate.com/api/llm/sail_ai_pages");
                const data = await response.json();

                // Extract relevant fields and sort alphabetically by PageTitle
                const sortedPages = data
                    .map((page) => ({
                        apiid: page.apiid,
                        PageTitle: page.PageTitle,
                        PageDescription: page.PageDescription,
                        PageUrl: page.PageUrl,
                    }))
                    .sort((a, b) => a.PageTitle.localeCompare(b.PageTitle));

                setPages(sortedPages);
            } catch (error) {
                console.error("Error fetching pages:", error);
            }
        };

        fetchPages();
    }, []);

    const handleOpenBrowser = (url, apiid) => {
        const aiWrapperUrl = `https://sailwingman.swancreate.com/ai-pagewrapper?url=${encodeURIComponent(
            url
        )}&apiid=${encodeURIComponent(apiid)}`;
        window.open(aiWrapperUrl, "_blank");
    };

    return (
        <Box
            sx={{
                backgroundColor: "#f5f7fa",
                width: "100%",
                minHeight: "100vh",
                overflow: "hidden",
            }}
        >
            {/* Header Section */}
            <Container
                sx={{
                    pt: 8,
                    pb: 4,
                    textAlign: "center",
                    color: "#333",
                }}
            >
                <Typography
                    variant="h3"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ color: "#003366", fontSize: "2.5rem" }}
                >
                    AI Pages Dashboard
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ fontSize: "1.25rem", color: "#555", maxWidth: "800px", margin: "0 auto" }}
                >
                    Explore AI-generated pages tailored for various educational resources.
                </Typography>
            </Container>

            {/* AI Pages Section */}
            <Box sx={{ py: 8, backgroundColor: "#eef3f8", textAlign: "center" }}>
                <Container>
                    <Grid container spacing={4} justifyContent="center">
                        {pages.map((page) => (
                            <Grid item xs={12} sm={6} md={3} lg={3} key={page.apiid}>
                                <Card
                                    sx={{
                                        height: "100%",
                                        backgroundColor: "#fff",
                                        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                                        textAlign: "center",
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        height="180"
                                        image={figLogo}
                                        alt="FIG Logo"
                                        sx={{ objectFit: "contain", p: 2 }}
                                    />
                                    <CardContent>
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ color: "#003366", fontSize: "1.2rem" }}
                                        >
                                            {page.PageTitle}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mt: 1,
                                                color: "#0056b3",
                                                fontSize: "1rem",
                                                fontWeight: "500",
                                            }}
                                        >
                                            {page.PageDescription}
                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            sx={{ mt: 2 }}
                                            onClick={() => handleOpenBrowser(page.PageUrl, page.apiid)}
                                        >
                                            FIG Agent Wrapper Page
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Footer */}
            <Box
                sx={{
                    py: 4,
                    textAlign: "center",
                    backgroundColor: "#f5f7fa",
                    color: "#444",
                }}
            >
                <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                    &copy; {new Date().getFullYear()} Swan AI Labs. All rights reserved.
                </Typography>
            </Box>
        </Box>
    );
};

export default Dashboard;
